import * as React from 'react';

import { IOrder, IOrderStatus, IDocument, IUserDownloadList } from '../../../infrastructure/interfaces';
import formatDate from '../../utils/formatDate';
import { getScrollbarWidth } from '../../../lib/helpers';

export interface IOrdersTableProps {
  orders: IOrder[];
  orderStatuses: IOrderStatus[];
  onDownload(document: IDocument): void;
  showShippingInfo(document: IDocument, order: IOrder): void;
  userDownloadList: IUserDownloadList[];
}

export default ({ orders, orderStatuses, onDownload, userDownloadList, showShippingInfo }: IOrdersTableProps) => (
  <div className="inner-home-container">
    <div className="my-product-row">
      User Order List
    </div>
    <table className="table-scrollable orders-table">
      <thead style={{ paddingRight: getScrollbarWidth() }}>
        <tr>
          <th>Order ID</th>
          <th>Date</th>
          <th>Order Name</th>
          <th>Type</th>
          <th>Quantity</th>
          <th>Shipping Addresses</th>
          <th>Download</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        {orders.map(o =>
          <tr key={o.id}>
            <td>{o.id}</td>
            <td>{formatDate(o.created_at)}</td>
            <td>{o.document.name}</td>
            <td>{o.document.type}</td>
            <td>{o.orderQuantitiesAddresses.map(o => o.orderQuantity).reduce((acc, x) => (acc + x))}</td>
            <td>
              <a href="#" role="button" onClick={() => showShippingInfo(o.document, o)}>
                View
               </a>
            </td>
            <td>
              <button 
                className="btn download" 
                onClick={() => onDownload(o.document)}
                disabled={userDownloadList.some(el => el.id === o.document.id)}
              >
                <img className="download-logo" src={require('../img/downloadsNew.svg')} />
                <span>PDF</span>
              </button>
            </td>
            <td>
              {(orderStatuses.find(s => s.id === o.status_id) || { status_name: null }).status_name}
            </td>
          </tr>)}
      </tbody>
    </table>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Home/components/OrdersTable.tsx